import { Box } from "@mui/material";
import { useSession } from "@src/appV2/Auth/api/useSession";

import { AccountSwitcherOptionGroupMobile } from "./AccountSwitcherOptionGroup";
import { type AccountSwitcherUser, type UserDetails } from "../../Shared/AccountSwitcher/types";

interface AccountSwitcherMenuWorkplaceMobileProps {
  workplaceDetails: UserDetails;
  onUserClicked: (user: AccountSwitcherUser) => void;
}

export function AccountSwitcherMenuWorkplaceMobile(props: AccountSwitcherMenuWorkplaceMobileProps) {
  const { workplaceDetails, onUserClicked } = props;
  const { profile } = useSession();
  const currentWorkplaceId = profile?.userId;

  return (
    <Box
      sx={{
        maxHeight: "400px",
        overflowY: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      <AccountSwitcherOptionGroupMobile
        userDetails={workplaceDetails}
        onUserClicked={onUserClicked}
        loadMoreLabel="Load more workplaces"
        selectedUserId={currentWorkplaceId}
      />
    </Box>
  );
}
